import { render, staticRenderFns } from "./TrademarkProvisionalStatusForm.vue?vue&type=template&id=69b43304&"
import script from "./TrademarkProvisionalStatusForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkProvisionalStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkProvisionalStatusForm.vue?vue&type=style&index=0&id=69b43304&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports